/* Sabpuja collection filter disclosure enhancements. Shopify owns filter and sort state. */
(function(){
  'use strict';
  function attach(root){
    if(root.dataset.spCollectionReady)return;
    root.dataset.spCollectionReady='true';
    var drawer=root.querySelector('[data-sp-filter-drawer]');
    if(!drawer)return;
    var summary=drawer.querySelector('summary');
    var close=drawer.querySelector('.sp-col-mobile-filters__head [data-sp-filter-close]');
    function closeDrawer(){drawer.open=false;if(summary)summary.focus();}
    drawer.querySelectorAll('[data-sp-filter-close]').forEach(function(button){
      button.addEventListener('click',closeDrawer);
    });
    drawer.addEventListener('toggle',function(){
      var open=drawer.open;
      document.body.classList.toggle('sp-col-filter-drawer-open',open);
      if(open&&close)close.focus();
    });
    document.addEventListener('keydown',function(event){
      if(event.key==='Escape'&&drawer.open){event.preventDefault();closeDrawer();}
    });
    window.addEventListener('pageshow',function(){document.body.classList.toggle('sp-col-filter-drawer-open',drawer.open);});
  }
  function boot(){document.querySelectorAll('[data-sp-col]').forEach(attach);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
}());